import React, { Component } from "react";
import FoldersMainContainer from "../folders/FoldersMainContainer";
import FetchResource from "../../utils/fetch_resource";

const api_base = process.env.API_URL;

export default class HomeMainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      pending_users: [],
      reqFilter: "",
      notice_message: "",
      display_notice: false,
      display_error: false,
      data_ready: false,
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.fetchUsers()
      .then(() => {
        if (this._isMounted) {
          this.setState({ data_ready: true });
        }
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          if (this._isMounted) {
            this.setState({ display_error: true });
          }
        }
      });
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this._isMounted) {
      if (this.props !== prevProps) {
        this.setState({
          userRole: this.props.userRole,
          userId: this.props.userId,
        });
      }
      if (prevState.filter !== this.state.filter) {
        this.fetchUsers();
      }
      this.pendingUsers();
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  fetchUsers = (event) => {
    let { reqFilter } = this.state;
    return FetchResource(api_base + "users", reqFilter, this);
  };

  pendingUsers = () => {
    this.state.users.map((user) => {
      if (user.roll_lookup == null) {
        this.state.pending_users.push(user);
      }
    });
  };

  render() {
    return (
      <div className="container" style={{ fontSize: "2rem" }}>
        <FoldersMainContainer />
      </div>
    );
  }
}
